import { Accordion, Typography, AccordionDetails, Button, useTheme } from '@mui/material';
import { ALARM_RULE_OPTIONS_TEXT, ALARM_RULE_OPTIONS_TITLE, DELETE_ACTION_NAME } from '../config';
import { StyledAccordionSummary } from './style';
import { ArrowDownIcon } from 'src/assets/icons/common/ArrowDownIcon';

type AccordionDeleteAlarmRuleProps = {
  handleClick: VoidFunction;
  title?: string;
  description?: string;
};

export const AccordionDeleteAlarmRule = ({
  handleClick,
  title = ALARM_RULE_OPTIONS_TITLE,
  description = ALARM_RULE_OPTIONS_TEXT,
}: AccordionDeleteAlarmRuleProps) => {
  const theme = useTheme();
  return (
    <Accordion defaultExpanded={false} sx={{ backgroundColor: theme.palette.background.default }}>
      <StyledAccordionSummary
        expandIcon={<ArrowDownIcon />}
        data-sm="alarm-rule-options-button"
        theme={theme}
      >
        <Typography sx={{ fontSize: '18px' }} variant="h5">
          {title}
        </Typography>
      </StyledAccordionSummary>
      <AccordionDetails sx={{ p: 0, backgroundColor: theme.palette.background.default }}>
        <Typography variant="body2">{description}</Typography>
        <Button
          color="error"
          variant="contained"
          sx={{ mr: 1, mt: '14px' }}
          data-sm="delete-alarm-rule-button"
          onClick={handleClick}
        >
          {DELETE_ACTION_NAME}
        </Button>
      </AccordionDetails>
    </Accordion>
  );
};
